<template>
  <div>
    <b-tabs active-nav-item-class="font-weight-bold text-light bg-info">
      <div v-for="(itemRegShif, indRegShif) in doctor" :key="indRegShif">
        <b-tab
          v-if="!itemRegShif.deleted"
          :title="itemRegShif.doctor.name"
          :class="{ kasallikT: $route.name == 'ArxivOne' }"
          title-link-class="mr-2 mt-1 text-light font-weight-bold bg-success"
          style="padding: 0px !important; position: relative;"
        >
          <div class="tek-card">
            <div>
              <div
                class="shif-sarlovha"
                :class="{
                  Arxive: $route.name == 'ArxivOne',
                  vazvrat: itemRegShif.backlog,
                  colorBacklog: !itemRegShif.backlog
                }"
              >
                <div style="display: flex; justify-content: space-between;">
                  <div v-if="!$store.state.kasTar">
                    <b-button
                      :disabled="
                        !(
                          localUser.doctor_id == itemRegShif.doctor_id ||
                          localUser.role == 'Admin'
                        )
                      "
                      class="navbarBtnTashxis"
                      v-b-modal="
                        'modal-shablon' + indRegShif + 'shifokor' + modalIdCom
                      "
                      @click="getShablon"
                      variant="primary"
                    >
                      <b-icon icon="collection"></b-icon>
                    </b-button>
                    <b-modal
                      :id="
                        'modal-shablon' + indRegShif + 'shifokor' + modalIdCom
                      "
                      size="lg"
                      :title="$t('Шаблонлар рўйхати')"
                      hide-footer
                    >
                      <Shablon
                        :modalIdCom="modalIdCom"
                        :indRegShif="indRegShif"
                        :shabType="'shifokor'"
                        :itemsShablon="itemsShablon"
                        @ShablonGet="getShablon"
                        @RowClickedShab="RowClickedShab"
                      />
                    </b-modal>
                  </div>
                  <b-button
                    style="margin-left: 10px;"
                    variant="primary"
                    @click="allPechat(itemRegShif, false)"
                    class="navbarBtnTashxis"
                    >
                    <b-icon icon="printer-fill"></b-icon>
                    Печать
                  </b-button>
                  <!-- <b-button
                    class="navbarBtnTashxis"
                    v-if="
                      !$store.state.kasTar &&
                        (localUser.role == 'Admin' ||
                          localUser.role == 'Registrator' ||
                          localUser.role == 'Shifokor')
                    "
                    v-b-modal="'modal-qosh' + 'shif' + indRegShif + modalIdCom"
                    @click="getQoshimcha()"
                    variant="primary"
                  >
                    <b-icon icon="plus-circle-fill"></b-icon>
                  </b-button> -->
                  <!-- <div class="ml-2">
                    <v-select
                      class="Tekshiruvchi-index-user"
                      :disabled="
                        localUser.role != 'Admin' &&
                        localUser.role != 'Registrator'
                      "
                      label="name"
                      :options="get_shifokor"
                      :reduce="option => option.id"
                      @input="changeShifokor($event, indRegShif)"
                      v-model="itemRegShif.doctor_id"
                    />
                  </div> -->
                  <div style="margin-left: 10px;">
                    <input
                      type="datetime-local"
                      class="input-datetime-local"
                      v-model="itemRegShif.date_doctor"
                    />
                  </div>
                  <!-- <div style="margin-left: 10px;">
                    {{ itemRegShif.date_time }}
                    <date-picker
                      style="width: 100%;"
                      id="tugkun"
                      v-model="itemRegShif.date_time"
                      format="DD MM YYYY HH:mm:ss"
                      value-type="X"
                      type="date"
                      :lang="lang"
                    ></date-picker>
                  </div> -->
                  <div>
                    <b-modal
                      :id="'modal-qosh' + 'shif' + indRegShif + modalIdCom"
                      size="xl"
                      hide-footer
                    >
                      <ShifokorVue
                        :shifKorigi="true"
                        :shifokor="qoshimchaShif"
                        :index="indRegShif"
                        @itemSh="itemShReg"
                      />
                    </b-modal>
                  </div>
                  <div>
                    <v-select
                      :filter="fuseSearch"
                      v-if="
                        localUser.role == 'Admin' ||
                          localUser.role == 'Registrator' ||
                          localUser.role == 'Kasser'
                      "
                      class="Tekshiruvchi-index-user ml-2"
                      id="naprovitel"
                      @input="changeRetsept(indRegShif)"
                      :options="Naprovitel"
                      :get-option-label="option => option.name"
                      :reduce="option => option.id"
                      v-model="itemRegShif.direct_id"
                    >
                      <template #option="{ name, direct_id }">
                        {{ name }}
                        <br />
                        <b>{{ direct_id }}</b>
                      </template>
                    </v-select>
                  </div>
                </div>
                <div class="delete-vaz">
                  <div
                    class="shif-price"
                    v-if="
                      localUser.role != 'Loborant' &&
                        localUser.role != 'Uzi ' &&
                        localUser.role != 'Shifokor'
                    "
                  >
                    <div style="width: 200px;">
                      {{ itemRegShif.price | numFormat }}
                    </div>
                  </div>
                  <!-- <div style="width: 100px;">
                    <b-form-checkbox
                      :class="{ kasallikT: $store.state.kasTar }"
                      style="display: flex; width: 100px;"
                      v-model="itemRegShif.vazvrat"
                      v-if="
                        localUser.role == 'Kasser' ||
                          localUser.role == 'Admin' ||
                          localUser.role == 'Registrator'
                      "
                      @change="Vazvrat(itemRegShif)"
                      :value="true"
                      :unchecked-value="false"
                    >
                      Возврат
                    </b-form-checkbox>
                  </div> -->
                  <b-button
                    :class="{ kasallikT: $store.state.kasTar }"
                    v-if="
                      !itemRegShif.pay_summa &&
                        !itemRegShif.vazvrat &&
                        (localUser.role == 'Admin' ||
                          localUser.role == 'Kasser' ||
                          localUser.role == 'Registrator' ||
                          Number(itemRegShif.date_time) > dateDeleted)
                    "
                    style="width: 30px; height: 30px; display: flex; justify-content: center;"
                    @click="deleteShif(indRegShif, itemRegShif)"
                    variant="outline-danger"
                  >
                    <b-icon style="width: 17px;" icon="trash"></b-icon>
                  </b-button>
                </div>
              </div>
              <div
                v-if="
                  localUser.role == 'Kasser' ||
                    localUser.role == 'Admin' ||
                    localUser.role == 'Shifokor' ||
                    localUser.role == 'Registrator'
                "
              >
                <Qoshimcha
                  :qoshimcha="itemRegShif.reg_doctor_category"
                  :dateDeleted="dateDeleted"
                  :classvazvrat="itemRegShif.vazvrat || !itemRegShif.backlog"
                  :backlog="backlog"
                  :indOta="indRegShif"
                  :modalIdCom="modalIdCom"
                  @SummaChange="SummaChange"
                  @vazvratQoshimcha="vazvratQoshimcha"
                  @delQosh="delQosh"
                />
              </div>
            </div>

            <!-- <div class="resept-div" v-if="!itemRegShif.vazvrat">
            </div> -->

            <!-- class="tashxis-style" -->
            <div
              :class="{ kasallikT: $store.state.kasTar }"
              v-if="!itemRegShif.vazvrat"
            >
              <!-- <b-button
                style="margin-bottom: 10px;"
                variant="primary"
                @click="allPechat(itemRegShif, false)"
                class="navbarBtnTashxis"
              >
                <b-icon icon="printer-fill"></b-icon>
                Печать
              </b-button> -->
              <!-- <b-button
                style="margin-bottom: 10px;"
                variant="primary"
                @click="allPechat(itemRegShif, true)"
                class="navbarBtnTashxis ml-2"
              >
                <b-icon icon="printer-fill"></b-icon>
                Печать маълумот нома
              </b-button> -->
              <!-- <AmbulatorKart
                :statsionar_text="itemRegShif.text"
                :modalIdCom="modalIdCom"
                :index="indRegShif"
                @statsionar_text_change="statsionar_text_change"
              /> -->
              <div class="vue-text-editor">
                <VueEditorText
                  :text="itemRegShif.text"
                  :indReg="indRegShif"
                  :table_type="itemRegShif.table_type"
                  :dataType="true"
                  :defaultHeigth="defaultHeigth"
                  @vueEditorText="vueEditorText"
                  @textChangeValueIndex="textChangeValueIndex"
                />
              </div>
              <!-- <div
                v-for="(itemQosh, indQosh) in itemRegShif.reg_doctor_category"
                :key="indQosh"
                class="qosh-parent"
              >
              <div>
                <div class="qosh-header">
                  <div>
                  </div>
                  <b class="qosh-name">{{ itemQosh.name }}</b>
                  <div>
                    <b-button
                      :class="{ kasallikT: $store.state.kasTar }"
                      v-if="backlog != 0 && !itemRegShif.vazvrat"
                      style="width: 30px; height: 30px; display: flex; justify-content: center;"
                      @click="delShifQosh(itemQosh.price, indRegShif, indQosh)"
                      variant="outline-danger"
                    >
                      <b-icon style="width: 17px;" icon="trash"></b-icon>
                    </b-button>
                  </div>
                </div>
                <div
                  style="background: #fff;"
                  v-if="!itemRegShif.vazvrat"
                >
                  <vue-editor
                    :disabled="localUser.doctor_id != itemRegShif.doctor_id"
                    v-model="itemQosh.text"
                    @input="ShifokorText(indRegShif)"
                  />
                </div>
              </div>
              </div> -->
            </div>
            <div
              class="resept-div"
              v-if="!itemRegShif.vazvrat"
            >
              <RetseptVue
                :modalIdCom="modalIdCom"
                :retsep="itemRegShif.registration_recipe"
                :doctor="itemRegShif"
                :doctor_id="itemRegShif.doctor_id"
                :indSh="indRegShif"
                @changeRetsept="changeRetsept"
              />
            </div>
          </div>
        </b-tab>
      </div>
    </b-tabs>
  </div>
</template>
<script>
import RetseptVue from "./Retsept.vue";
import Shablon from "./Shablon.vue";
import Qoshimcha from "../Qoshimcha.vue";
import ShifokorVue from "./Shifokor.vue";
import AmbulatorKart from "./AmbulatorKart.vue";
import VueEditorText from "../VueEditorText.vue";
export default {
  props: [
    "get_shifokor",
    "doctor",
    "backlog",
    "modalId",
    "modalIdCom",
    "created_at",
    "Naprovitel",
    "dateDeleted"
  ],
  components: {
    RetseptVue,
    Shablon,
    Qoshimcha,
    ShifokorVue,
    AmbulatorKart,
    VueEditorText
  },
  data() {
    return {
      newShablon: {
        doctor_id: JSON.parse(localStorage.getItem("user")).id,
        name: "",
        text: "",
        doc_type: "reg_doctor"
      },
      localUser: JSON.parse(localStorage.getItem("user")),
      itemsShablon: [],
      qoshimchaShif: [],
      pechatChange: [],
      // shifokor: [],
      defaultHeigth: "height: 1180px;",
      logoStatus: true,
      textChangeValue: {
        index: null,
        key: null
      }
    };
  },

  methods: {
    // doriSaqlash(data, indSh, index) {
    //   // this.doctor[indSh].registration_recipe[index].pill_id = data.id
    // },
    vueEditorText(val, index, ind, textValue, type) {
      this.doctor[index].text = val;
      if (
        (this.localUser.role == "Admin" || this.localUser.role == "Shifokor")
      ) {
        this.doctor[index].update = true;
      }
    },
    statsionar_text_change(data, doc_type, index) {
      this.doctor[index].update = true;
      this.doctor[index].text = data;
    },
    // getShifokor() {
    //   let self = this;
    //   axios({
    //     method: "get",
    //     url: "/doctor/all"
    //   }).then(res => {
    //     if (res) {
    //       self.shifokor = res.data
    //     }
    //   });
    // },
    ShifokorShablonClose(index) {
      this.newShablon = {
        doctor_id: JSON.parse(localStorage.getItem("user")).id,
        name: "",
        text: "",
        doc_type: "reg_doctor"
      };
      this.$bvModal.hide(`${"modal-new-shab-creat" + index + this.modalIdCom}`);
    },
    ShifokorShablon(index) {
      let self = this;
      axios({
        method: "post",
        url: "/shablon_doctor/create",
        data: self.newShablon
      }).then(res => {
        if (res) {
          self.newShablon = {
            name: "",
            text: "",
            doctor_id: JSON.parse(localStorage.getItem("user")).id,
            doc_type: "reg_doctor"
          };
          self.$bvModal.hide(
            `${"modal-new-shab-creat-" + index + self.modalIdCom}`
          );
        }
      });
    },
    changeShifokor(e, ind) {
      this.doctor[ind].update = true;
      this.doctor[ind].reg_doctor_category.forEach(el => {
        el.doctor_id = e;
      });
      this.get_shifokor.forEach(el => {
        if (el.id == e) {
          this.doctor[ind].doctor.name = el.name;
        }
      });
    },
    clicknewShablon(index) {
      this.newShablon.text = this.doctor[index].text.toString();
      this.newShablon.table_type = this.doctor[index].table_type;
    },
    changeRetsept(ind) {
      this.doctor[ind].update = true;
    },
    getQoshimcha() {
      let self = this;
      axios({
        method: "get",
        url: "/doctor_category/all"
      }).then(res => {
        if (res) {
          // self.qoshimchaShif = res.data.data;
          let x = [];
          res.data.data.forEach(item => {
            const existingType = x.find(r => r.name === item.bolim.name);
            if (existingType) {
              existingType.type.push(item);
            } else {
              x.push({ name: item.bolim.name, type: [item] });
            }
          });
          self.qoshimchaShif = x;
        }
      });
    },
    itemShReg(item, index) {
      let x = 0;
      if (this.$store.state.bemor.imtiyoz_type == "Imtiyozsiz") {
        if (this.$store.state.bemor.citizen) {
          x = item.citizen_price;
        } else {
          x = item.price;
        }
      }
      this.doctor[index].update = true;
      this.doctor[index].price += x;
      this.doctor[index].backlog += x;
      this.$emit("shifAdd", x, true);
      this.doctor[index].reg_doctor_category.push({
        id: item.id,
        doctor_id: this.doctor[index].doctor_id,
        name: item.name,
        price: x,
        text: "",
        rastod_type: item.rastod_type,
        rasxod_usd: item.currency_type ? item.rasxod_summa : 0,
        rasxod_uzs: !item.currency_type ? item.rasxod_summa : 0,
        currency_type: item.currency_type,
        vazvrat: false
      });
    },

    deleteShif(ind, item) {
      let x = item.price;
      this.$emit("delShif", x, false);
      this.doctor[ind].deleted = true;
      // this.doctor.splice(ind, 1);
    },
    delShifQosh(price, indOta, ind) {
      this.$emit("delShif", price, false);
      this.doctor[indOta].price -= x;
      this.doctor[indOta].reg_doctor_category.splice(ind, 1);
    },
    delQosh(x, index, type, v) {
      if (v) {
        this.$emit("delShif", x, type, v);
      } else {
        this.$emit("delShif", x, type);
        this.doctor[index].price -= x;
        this.doctor[index].backlog -= x;
        this.doctor[index].update = true;
      }
    },
    SummaChange(price, index, type) {
      this.doctor[index].price += price;
      this.doctor[index].backlog += price;
      (this.doctor[index].update = true), this.$emit("shifAdd", price, type);
    },
    getShablon() {
      let self = this;
      axios({
        method: "post",
        url: "/shablon_doctor/shablonOne",
        data: {
          doctor_id: self.localUser.id,
          doc_type: "shifokor"
        }
      }).then(res => {
        if (res) {          
          self.itemsShablon = res.data.data;
        }
      });
    },
    RowClickedShab($events, indRegShif) {
      let text = JSON.parse(this.doctor[indRegShif].text.toString());
      let shablonText = JSON.parse($events.text.toString());
      this.doctor[indRegShif].update = true;
      this.doctor[indRegShif].table_type = $events.table_type;
      for (let index = 0; index < shablonText.length; index++) {
        const el = shablonText[index];
        if (text[index]) {
          text[index][`${text[index].key}`] += el[`${el.key}`];
        } else {
          text.push(el);
        }
      }
      // text[0].value += $events.text
      this.doctor[indRegShif].text = JSON.stringify(text);
      this.textChangeValue = {
        index: null,
        key: null
      };
      // this.doctor[indRegShif].text += $events.text;
      this.$bvModal.hide(
        `${"modal-shablon" + indRegShif + "shifokor" + this.modalIdCom}`
      );
    },
    textChangeValueIndex(key, index) {
      this.textChangeValue = {
        index: index,
        key: key
      };
    },
    // pechat(itemOta, item){
    //   let t = {};
    //   let child = []
    //   const find = this.pechatChange.findIndex(el => el.id == itemOta.id)
    //   if(find == -1){
    //     child.push(item)
    //     this.pechatChange.push({
    //       id: itemOta.id,
    //       name: itemOta.name,
    //       registration_recipe: itemOta.registration_recipe,
    //       reg_doctor_category: child
    //     })
    //   } else {
    //     const findChild = this.pechatChange[find].reg_doctor_category.findIndex(el => el.id == item.id);
    //     if(findChild == -1) {
    //       this.pechatChange[find].reg_doctor_category.push(item)
    //     } else {
    //       if(this.pechatChange[find].reg_doctor_category.length == 1){
    //         this.pechatChange.splice(find, 1)
    //       } else {
    //         this.pechatChange[find].reg_doctor_category.splice(findChild, 1)
    //       }
    //     }
    //   }
    // },
    allPechat(item, type) {
      let t = {};
      let x = [];
      x.push(item);
      t = {
        bemorId: this.$store.state.bemor.id,
        type: this.logoStatus,
        name: this.$store.state.bemor.fullname,
        gender: this.$store.state.bemor.gender,
        birthday: this.$store.state.bemor.birthday,
        create_at: this.created_at,
        doctor: x,
        type: type
      };
      localStorage.setItem("Bayonot", JSON.stringify(t));
      // this.$router.push("/user");
      const rout = this.$router.resolve({
        path: "/user-bayonot"
      });
      window.open(rout.href, "_blank");
    },
    vazvratQoshimcha(x, type, v, index, item) {
      if (type == true) {
        this.doctor[index].price -= x;
        this.doctor[index].update = true;
      } else {
        this.doctor[index].price += x;
        this.doctor[index].update = false;
      }
      this.$emit("delShif", x, type, v, item);
    },
    Vazvrat(item) {
      let x = "vazvrat";
      this.$emit("delShif", item.price, item.vazvrat, x, item);
    },
    fuseSearch(options, search) {
      const fuse = new Fuse(options, {
        keys: ["name", "direct_id"],
        shouldSort: true
      });
      return search.length
        ? fuse.search(search).map(({ item }) => item)
        : fuse.list;
    }
  },
  mounted() {
    // this.getShifokor()
  }
};
</script>
<style>
.tek-card {
  border: 1px solid #ccc;
  border-radius: 10px;
  min-height: 0px;
  background: #fff;
  padding: 10px;
}
.pecat-change {
  /* background: #28a745; */
  padding: 2px;
  /* border-radius: 50%; */
  /* display: flex; */
  /* justify-content: center; */
  position: relative;
  /* top: -50px; */
}
.colorBacklog {
  background: rgba(6, 247, 66, 0.432);
}
.shif-price {
  margin-right: 20px;
  font-size: 18px;
  font-weight: 600;
  display: flex;
  border: 1px solid #ccc;
  background: #fff;
  border-radius: 7px;
  padding: 0px 1px;
}
.resept-div {
  margin-top: 20px;
}
.delete-vaz {
  display: flex;
  text-align: center;
}
.qosh-parent {
  margin-top: 20px;
  border: 1px solid rgb(46, 165, 255);
  border-radius: 10px;
  background: #f0f0f0;
  padding: 10px;
}
.qosh-header {
  display: flex;
  border: 1px solid rgb(46, 165, 255);
  border-radius: 10px;
  background: #fff;
  padding: 5px;
  margin-bottom: 10px;
  justify-content: space-between;
}
.qosh-name {
  font-size: 22px;
  text-align: center;
  color: rgb(70, 112, 250);
}
.vazvrat {
  background: #ff00004a !important;
}
.navbarBtnTashxis {
  color: #fff;
  border: 1px solid #fff;
  padding: 3px 15px;
  background: #0b0bdd;
  box-shadow: 5px 8px 10px rgba(25, 95, 176, 0.3);
  border-radius: 8px;
}
/* .tashxis-style{
  width: 890px;
  height: 1260px;
} */
/* .tashxis-style .ql-editor p{
  font-size: 18px;
  font-weight: 500;
} */
.shif-sarlovha {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  background: rgba(7, 100, 172, 0.058);
  border: 1px solid rgb(46, 165, 255);
  padding: 7px;
  border-radius: 10px;
}
</style>
